/** @format */
import React, { useRef, useState, useCallback } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import "primeflex/primeflex.css";
import { InputTextarea } from "primereact/inputtextarea";
import "../../style/news.css";
import { useQueryClient } from "@tanstack/react-query";
import useAddSurvey from "./hooks/useAddSurvey";
import { useNavigate } from "react-router-dom";
import ThreeDotsLoader from "../common/ThreeDotsLoader";

const Create = ({ discardSurveyHandler }) => {
  let [surveyDetails, setSurveyDetails] = useState({
    name: "",
    whySurvey: "",
  });
  let { name, whySurvey } = surveyDetails;
  const queryClient = useQueryClient();
  const mutation = useAddSurvey();
  const navigate = useNavigate();
  let formRef = useRef(null);
  let toastRef = useRef(null);
  const onSurveyNameChangeHandler = useCallback(
    (e) => {
      let value = e.target.value;
      setSurveyDetails((prev) => ({ ...prev, name: value }));
    },
    [setSurveyDetails]
  );

  const onWhySurveyChangeHandler = useCallback(
    (e) => {
      let value = e.target.value;
      setSurveyDetails((prev) => ({ ...prev, whySurvey: value }));
    },
    [setSurveyDetails]
  );
  let addNewSurveyHandler = useCallback(() => {
    if (!formRef.current.checkValidity()) {
      formRef.current.reportValidity();
    } else {
      mutation.mutate(
        {
          title: name,
          need: whySurvey,
        },
        {
          onSuccess: () => {
            toastRef.current.show({
              severity: "success",
              summary: "Success",
              detail: "New Survey created successfully",
              life: 1000,
            });
            queryClient.invalidateQueries({
              queryKey: ["getAllSurvey"],
            });
          },
          onError: () => {
            toastRef.current.show({
              severity: "error",
              summary: "Error",
              detail: "Error while creating new Survey",
              life: 1000,
            });
          },
        }
      );
    }
  }, [mutation, name, whySurvey, queryClient]);
  return (
    <>
      <Toast
        ref={toastRef}
        baseZIndex={20000}
        onRemove={() => {
          if (mutation.isError) {
            discardSurveyHandler();
          }
          if (mutation.isSuccess) {
            let { surveyId } = mutation.data.data;
            navigate(`/survey/edit/${surveyId}`);
          }
        }}
      />
      {mutation.isLoading ? (
        <div className='wtg__loader'>
          <ThreeDotsLoader />
        </div>
      ) : null}
      <form noValidate ref={formRef}>
        <div className='field grid'>
          <label htmlFor='surveyName' className='col-2 md:col-4'>
            Enter Survey Name
          </label>
          <div className='col-10 md:col-8'>
            <InputText
              id='surveyName'
              type='text'
              required
              className='w-100'
              value={name}
              onChange={onSurveyNameChangeHandler}
            />
          </div>
        </div>
        <div className='field grid'>
          <label htmlFor='whyThisSurvey' className='col-2 md:col-4 align-items-start'>
            Why This Survey?
          </label>
          <div className='col-10 md:col-8'>
            <InputTextarea
              id='whyThisSurvey'
              required
              className='mx-0 w-100'
              rows={5}
              value={whySurvey}
              onChange={onWhySurveyChangeHandler}
            />
          </div>
        </div>
      </form>
      <Create.Footer addNewSurveyHandler={addNewSurveyHandler} discardSurveyHandler={discardSurveyHandler} />
    </>
  );
};

Create.Footer = ({ addNewSurveyHandler, discardSurveyHandler }) => (
  <div className='p-dialog-footer'>
    <Button label='Add' onClick={addNewSurveyHandler} className='p-button p-button-sm btn3' />
    <Button label='Discard' onClick={discardSurveyHandler} className='p-button p-button-sm btn3' />
  </div>
);
export default Create;
